import { axiosInstance } from "./axios";

export const GetParticipantRemainingSeansHaklari = async(search="",deletedUsers="false") => {
  return await axiosInstance
    .get(`/reports/remainingSession?search=${search}&deletedUsers=${deletedUsers}`)
    .then(res =>  res.data)
    .catch((err) => console.log("e", err));
};
